module.exports = __webpack_public_path__ + "img/Dantam Hair 48.055bf98d.jpg";